import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../app.constant';
@Injectable({
  providedIn: 'root'
})
export class CardService {
  private host = environment.apiHost;
  private baseUrl = `${this.host}/savecard`;
  // private baseUrl = "http://192.168.0.5:8081/savecard";
  constructor(private http: HttpClient) { }
  saveCardDetails(cardDetails: any): Observable<any> {
    return this.http.post(`${this.baseUrl}`, cardDetails);
  }
}
